import React, { Component } from 'react'

export default class Features extends Component {
  render() {
    return (
      <div>
  <section id="features" className="features section">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="section-title">
            <h3 className="wow zoomIn" data-wow-delay=".2s" style={{visibility: 'visible', animationDelay: '0.2s', animationName: 'zoomIn'}}>Features</h3>
            <h2 className="wow fadeInUp" data-wow-delay=".4s" style={{visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp'}}>M4Academy <span title="Learning Management System">LMS</span> has awesome stunning features</h2>
            <p className="wow fadeInUp" data-wow-delay=".6s" style={{visibility: 'visible', animationDelay: '0.6s', animationName: 'fadeInUp'}}>
              Our Learning Management System (LMS) is designed with alot of features to make learning easy and fun, a few of them are listed below .</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-4 col-md-6 col-12">
          {/* Start Single Feature */}
          <div className="single-feature wow fadeInUp" data-wow-delay=".2s" style={{visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp'}}>
            <i className="lni lni-heart" />
            <h3>Simple &amp; Light</h3>
            <p>Appmeet is a completely creative, lightweight, clean &amp; super responsive app landing page.
            </p>
          </div>
          {/* End Single Feature */}
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          {/* Start Single Feature */}
          <div className="single-feature wow fadeInUp" data-wow-delay=".4s" style={{visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp'}}>
            <i className="lni lni-grid-alt" />
            <h3>Super Responsive</h3>
            <p>Appmeet is a completely creative, lightweight, clean &amp; super responsive app landing page.
            </p>
          </div>
          {/* End Single Feature */}
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          {/* Start Single Feature */}
          <div className="single-feature wow fadeInUp" data-wow-delay=".6s" style={{visibility: 'visible', animationDelay: '0.6s', animationName: 'fadeInUp'}}>
            <i className="lni lni-bug" />
            <h3>Bug Free Code</h3>
            <p>Appmeet is a completely creative, lightweight, clean &amp; super responsive app landing page.
            </p>
          </div>
          {/* End Single Feature */}
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          {/* Start Single Feature */}
          <div className="single-feature wow fadeInUp" data-wow-delay=".2s" style={{visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp'}}>
            <i className="lni lni-heart" />
            <h3>Fully &amp; Responsive</h3>
            <p>Appmeet is a completely creative, lightweight, clean &amp; super responsive app landing page.
            </p>
          </div>
          {/* End Single Feature */}
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          {/* Start Single Feature */}
          <div className="single-feature wow fadeInUp" data-wow-delay=".4s" style={{visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp'}}>
            <i className="lni lni-grid-alt" />
            <h3>High Quality Videos</h3>
            <p>Appmeet is a completely creative, lightweight, clean &amp; super responsive app landing page.
            </p>
          </div>
          {/* End Single Feature */}
        </div>
        <div className="col-lg-4 col-md-6 col-12">
          {/* Start Single Feature */}
          <div className="single-feature wow fadeInUp" data-wow-delay=".6s" style={{visibility: 'visible', animationDelay: '0.6s', animationName: 'fadeInUp'}}>
            <i className="lni lni-bug" />
            <h3>Embedded Chat System</h3>
            <p>M4Academy Learning Management System is embeded with a chat system so student can communicate with tutors easily.
            </p>
          </div>
          {/* End Single Feature */}
        </div>
      </div>
    </div>
  </section>
</div>

    )
  }
}
